import { sortBy } from 'lodash';

export function useDefaultHardwareBinding(product) {
    if (!product?.hardwareBindings) return null;
    if (product.hardwareBindings.length < 1) return null;
    return sortBy(product.hardwareBindings, 'orderNumber')[0].id;
}
